import React from 'react'
import './CardThree.css'

function CardThree() {
    return (
        <div className="cardThree">
            <h2 className="h2">Learn and grow with award-winning support<br/> and a thriving community behind you.</h2>
            <p>You don't have to go it alone. Master the inbound methodology and get the most out<br/> of your tools with HubSpot's legendary customer support team and a community of<br/> thousands of marketing and sales pros just like you.</p>
        
            <div className="small_cards">
            <div className="components">
            <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_agency.svg" 
            alt="" />
            <div className="text">
                <h1>150</h1>+
            </div>
            <p>HubSpot user group</p>
        </div>

        <div className="components">
            <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_blog.svg" 
            alt="" />
            <div className="text">
                <h1>7M</h1>+
            </div>
            <p>Monthly Visits</p>
        </div>


        <div className="components">
            <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_academy.svg" 
            alt="" />
            <div className="text">
                <h1>276K</h1>+
            </div>
            <p>certified professionals</p>
        </div>


        <div className="components">
            <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_inbound.svg" 
            alt="" />
            <div className="text">
                <h1>26K</h1>+
            </div>
            <p>registered attendees</p>
        </div>


        <div className="components">
            <img
            className="icon"
            src="https://cdn2.hubspot.net/hubfs/53/HubSpot-App-Marketplace-White.png" 
            alt="" />
            <div className="text">
                <h1>500</h1>+
            </div>
            <p>Integrations</p>
        </div>


        <div className="components">
            <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_globe.svg" 
            alt="" />
            <div className="text">
                <h1>6</h1>
            </div>
            <p>Languages</p>
        </div>
    

        <div className="components">
            <img src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_followers.svg" 
            alt="" />
            <div className="text">
                <h1>2.6M</h1>+
            </div>
            <p>social followers</p>
        </div>

        <div className="components">
            <img src="https://cdn2.hubspot.net/hubfs/53/Lists.svg" 
            alt="" />
            <div className="text">
                <h1>86000</h1>+
            </div>
            <p>Customers</p>
        </div>

            </div>

    
        </div>
    )
}

export default CardThree
